export default __webpack_public_path__ + "static/media/logo-brand.485c6fcc.png";